import 'styled-components/macro';
import 'antd/dist/reset.css';
import 'common/styling/global-style.css';
import 'moment/locale/es';
import 'moment/locale/fr';

import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment';

import Root from './root';
import AppComponent from './app';

moment.locale('es');

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <Root>
      <AppComponent />
    </Root>
  );
} else {
  /**
   * No need to Handle the case where the 'root' element has not been found.
   * Because, normaly, it will never happen
   */
}
